import { RouteType } from "types/RouteType";
// import loadHoistOverviewRoute from "./LoadHoistOverview/loadHoistOverview.Route";
// import loadHoistSummaryRoute from "./LoadHoistSummary/loadHoistSummary.Route";
// import loadHoistTrackerRoute from "./LoadHoistTracker/loadHoistTracker.Route";
// import productionOverviewChartRoute from "./ProductionOverviewChart/productionOverviewChart.Route";
// import scheduleGeneratorRoute from "./ScheduleGenerator/ScheduleGenerator.Route";
import ntxProductionScheduleRoute from "./NTXProductionSchedule/ntxProductionSchedule.Route";

const schedulingRoutesList: RouteType[] = [
    // loadHoistOverviewRoute,
    // loadHoistSummaryRoute,
    // ...loadHoistTrackerRoute,
    // ...productionOverviewChartRoute,
    // scheduleGeneratorRoute,
    ...ntxProductionScheduleRoute,
];

export default schedulingRoutesList;
